export class OrganisationAuditEntry {
    constructor(
        public id: string,
        public changes: { [key: string]: any },
        public organisationId: string,
        public userId: string | null,
        public dateTime: Date
    ) { }
}
